module.exports = __webpack_public_path__ + "static/output3-0c7e01cdf0e6833cd73c350e3c5fff87.mp4";